import styled from '@emotion/styled';
import {
  OL_COLOUR_BLACK_10,
  OL_COLOUR_BLACK_4,
  OL_COLOUR_BLACK_90_HEX,
} from 'src/web/components/Style/colours';

export const StyledTimesButton = styled('button')({
  background: 'transparent',
  border: 'none',
});

export const GroupListItem = styled('div')({
  fontSize: 14,
  padding: 20,
  color: OL_COLOUR_BLACK_90_HEX,
  display: 'flex',
  justifyContent: 'space-between',

  '&:not(:last-child)': {
    borderBottom: `1px solid ${OL_COLOUR_BLACK_10}`,
  },
});

export const GroupNameHeading = styled(GroupListItem)({
  fontSize: 14,
  background: OL_COLOUR_BLACK_4,
  fontWeight: 600,
});

export const GroupList = styled('div')({
  marginTop: 20,
  border: `1px solid ${OL_COLOUR_BLACK_10}`,
});
